import React, { Component } from "react";
import { Button } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './ResetOrderPlannerData.css';

export function clearOrderDataFromLocalStorage(fromResetButton) {
    //localStorage.removeItem('address');
    //localStorage.removeItem('state');
    //localStorage.removeItem('zip');
    //localStorage.removeItem('addressName');
    //localStorage.removeItem('city');
    localStorage.removeItem('badPO');
    localStorage.removeItem('deliveryDate');
    localStorage.removeItem('deliveryModeCode');
    localStorage.removeItem('deliveryModeDescription');
    localStorage.removeItem('orderPO');
    localStorage.removeItem('orderPlannerContact');
    localStorage.removeItem('orderPlannerContactEmail');
    localStorage.removeItem('orderPlannerContactName');
    localStorage.removeItem('orderPlannerContactPhone');
    localStorage.removeItem('orderPlannerReview');
    localStorage.removeItem('specialInstructions');
    localStorage.removeItem('requireCC');
    localStorage.removeItem('requirePO');
    localStorage.removeItem('requireUniquePO');
    localStorage.removeItem('isSalesQuote');
    localStorage.removeItem('shipComplete')

    var arr = [];
    // Iterate over localStorage and insert the keys that meet the condition into arr
    for (var i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).substring(0, 6) === 'order:') {
            arr.push(localStorage.key(i));
        }
    }

    // Remove order items
    for (var i = 0; i < arr.length; i++) {
        localStorage.removeItem(arr[i]);
    }

    if (fromResetButton === true) {
        window.open('/order-planner', '_self');
    }
}

const ResetOrderPlannerDataButton = function() {
    return (
        <Button className="btn-danger"
            onClick={() => {
                const options = {
                    childrenElement: () => <div />,
                    customUI: ({ onClose }) => {
                        return (
                            <div className='custom-ui'>
                                <h1>Start Over?</h1>
                                <p>Are you sure you want to start over? This will clear all current order data.</p>
                                <button onClick={onClose}>No</button>
                                <button className="confirm-reset"
                                    style={{ marginLeft: '15px' }}
                                    onClick={() => {
                                    clearOrderDataFromLocalStorage(true)
                                }}>Yes, start over!</button>
                            </div>
                        )
                    },
                    willUnmount: () => { },
                    onClickOutside: () => { },
                    onKeypressEscape: () => { }
                }

                confirmAlert(options)
            }}>
            Reset
        </Button>
    );
}

export default ResetOrderPlannerDataButton;


// WEBPACK FOOTER //
// ./src/components/common/ResetOrderPlannerData.js